const ContentPillar = {
    pillar: "",
    description: "",
    subcategories: "",
    active: true
};
  
  export default ContentPillar;
  